module.exports = __webpack_public_path__ + "static/media/apple_logo.064cfd44.png";